//
// gcatCodeIconColor
//
const gcatCodeIconColorsSrc = {
  police: '#1b2bb3',
  fire: 'red',
  medical: '#03995a',
  security: '#f78d20',
  // 'town',
  social: '#785448',
  // 'services',
  // 'paxity', 'users', 'rescue',

  // events:
  // facilities: '#1b2bb3',
  // it:
  // services:
  // paxity:
};

export default (gcatCode) => (
  gcatCodeIconColorsSrc[gcatCode] || 'black');
